"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockClass = void 0;
const getAllMethodsOfClass = (obj) => {
    // @ts-ignore
    const getMethods = (obj) => Reflect.ownKeys(obj.prototype).filter(item => item !== 'constructor');
    const getAllMethodsHelper = (obj, list) => {
        // @ts-ignore
        if (!obj || !obj.prototype) {
            return list;
        }
        const methods = getMethods(obj);
        // @ts-ignore
        return getAllMethodsHelper(Reflect.getPrototypeOf(obj), list.concat(methods));
    };
    // @ts-ignore
    return getAllMethodsHelper(obj, []);
};
const mockClass = (clazz, ...mockableProperties) => {
    const keys = getAllMethodsOfClass(clazz);
    const initFunctionKeys = (obj) => {
        keys.forEach(key => {
            obj[key] = (...args) => unimplemented(args);
        });
    };
    const initMockableProperties = (obj) => {
        mockableProperties.forEach(value => {
            obj[value] = undefined;
        });
    };
    const methodCalledRecorder = keys.reduce((previousValue, currentValue) => {
        previousValue[currentValue] = 0;
        return previousValue;
    }, {});
    const fn = () => { };
    fn.isMock = true;
    initFunctionKeys(fn);
    initMockableProperties(fn);
    fn.mock = (property, implementation) => {
        // @ts-ignore
        if (typeof implementation === 'function' && !implementation.isMock) {
            // @ts-ignore
            fn[property] = (...args) => {
                methodCalledRecorder[property] = methodCalledRecorder[property] + 1;
                return implementation(...args);
            };
        }
        else {
            // @ts-ignore
            fn[property] = implementation;
        }
    };
    fn.mockClear = (params = { implementations: true, invocations: true }) => {
        const implementations = params.implementations ?? true;
        const invocations = params.invocations ?? true;
        if (implementations) {
            initFunctionKeys(fn);
            initMockableProperties(fn);
        }
        if (invocations) {
            Object.keys(methodCalledRecorder).forEach(key => {
                methodCalledRecorder[key] = 0;
            });
        }
    };
    fn.timesCalled = (methodName) => methodCalledRecorder[methodName];
    // @ts-ignore
    return fn;
};
exports.mockClass = mockClass;
const unimplemented = (...args) => {
    throw new Error('Unimplemented');
};
